// AI Generated Test
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';
import { PAGE_PERFORMANCE_AUDIT_RELATIONS } from '../../constants/performance-audit-relations';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { ExporterService } from '@client/app/modules/export/services/exporter.service';
import { PagePerformanceAuditInfoService } from '../../services/page-performance-audit-info/page-performance-audit-info.service';
import { PagePerformancePageDetailsService } from '../../services/page-performance-page-details/page-performance-page-details.service';
import { AuditImpactService } from '../../services/audit-impact/audit-impact.service';
import { PagePerformanceOpportunitiesService } from './service/opportunities.service';
import { safeClone } from '@client/app/shared/utils/object-utils';
import {
    PagePerformanceDialogsAuditDetailsComponent,
} from '@client/app/modules/page-performance/dialogs/audit-details/audit-details.component';

@Component({
    selector: 'page-performance-page-details-opportunities',
    standalone: false,
    template: `
<div class="page-performance-page-details-performance-opportunities">
    <div class="d-flex align-items-center mb-0 mt-3">
        <span class="fa-2x fa-fw mr-2 text-link"
              aria-hidden="true"
              [class]="['PAGE_PERFORMANCE', 'PERFORMANCE', 'OPPORTUNITIES'] | monIcons">
        </span>
        <div class="d-flex align-items-center">
            <h2 class="font-weight-300 my-1" translate>
                Opportunities
            </h2>
        </div>
    </div>
    <p class="text-gray-small ml-8 mb-4" translate>
        Opportunities present areas for improvement that can boost the
        page load speed of your site and improve its performance. The
        suggestions provided are highly targeted, with examples including
        enabling text compression and identifying render-blocking resources.
        Recommendations are presented in a way that is easy to understand
        with documentation coming from Google resources.
    </p>
    <mon-tabs [(status)]="tab"
              [options]="tabs"
              (onStatus)="setTab($event)"
              (onSearch)="onSearch($event)"
              [search]="search"
              [minSearchLength]="minSearchCharacterLimit"
              [showSearch]="true"
              [showFiltersBtn]="true"
              [(isFiltersOpen)]="isFiltersOpen">
        <button type="button"
                class="btn btn-border-radius btn-secondary export-btn-height mr-1 font-size-1-1"
                ngCsv
                [data]="exportCsv()"
                [quoteStrings]="true"
                fieldSep=";"
                [filename]="csvFileName()"
                [attr.aria-label]="'Export CSV' | translate">
            <span class="fas fa-download fa-lg pr-1" aria-hidden="true"></span>
            <span translate>Export</span>
        </button>
    </mon-tabs>
    <div class="card panel-monsido-card">
        <div class="card-body">
            <div *ngIf="isFiltersOpen" class="merge-t-8 merge-r-16 merge-l-16 mb-3">
                <table-filters [(open)]="isFiltersOpen"
                               name="filters"
                               [(ngModel)]="filters"
                               [filters]="availableFilters"
                               (onChanges)="onFiltersChange($event)">
                </table-filters>
            </div>
            <table class="table table-fixed table-hover table-vertial-align"
                   *ngIf="audits.length > 0">
                <thead>
                <tr>
                    <th class="col-sm-30"
                        monTableSort
                        monSortBy="title"
                        [monSortDirection]="sortDirection"
                        [monCurrentlySortedBy]="sortType"
                        (monOnSorted)="onSortPage({direction: $event.direction, by: $event.by})">
                        {{ 'Audit' | translate }}
                    </th>
                    <th class="col-sm-6 text-right pr-7"
                        monTableSort
                        monSortBy="difficulty"
                        [monSortDirection]="sortDirection"
                        [monCurrentlySortedBy]="sortType"
                        (monOnSorted)="onSortPage($event)">
                        <span translate>Difficulty</span>
                        <span class="fas fa-question-circle"
                              aria-hidden="true"
                              [ngbTooltip]="'Indicates the difficulty to fix an audit error' | translate">
                        </span>
                    </th>
                    <th class="col-sm-6"
                        monTableSort
                        monSortBy="priority"
                        [monSortDirection]="sortDirection"
                        [monCurrentlySortedBy]="sortType"
                        (monOnSorted)="onSortPage($event)">
                        {{ 'Priority' | translate }}
                    </th>
                    <th class="col-sm-4 text-right"
                        translate>
                        Relevant for
                    </th>
                    <th class="col-sm-6">&nbsp;</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let audit of audits; trackBy: trackByAuditId">
                    <td>
                        <div class="text-ellipsis text-bold">
                            <span class="inline-block">{{audit.title}}</span>&nbsp;
                            <span class="inline-block" *ngIf="audit.displayValue">
                                - {{audit.displayValue}}
                            </span>
                        </div>
                        <mon-markdown-viewer *ngIf="audit.description"
                                           class="markdown-container"
                                           [monMarkdown]="audit.description">
                        </mon-markdown-viewer>
                    </td>
                    <td class="text-right pr-7">
                            {{ getDifficulty(audit.id) }}
                    </td>
                    <td>
                        <span [ngClass]="getLabelClass(audit)">
                            {{getImpactTranslation(audit)}}
                        </span>
                    </td>
                    <td class="text-right">
                        {{audit.metrics.join(', ')}}
                    </td>
                    <td class="text-right">
                        <button type="button"
                                (click)="openDetails(audit)"
                                class="btn btn-border-radius btn-secondary"
                                translate>
                            Details
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>
            <div *ngIf="audits.length === 0">
                <div class="font-weight-300 text-grey text-center text-size-h3"
                     translate>
                    No opportunities were found
                </div>
            </div>
        </div>
    </div>
</div>
    `,
})
export class PagePerformancePageDetailsOpportunitiesComponent implements OnInit {
    tab: string = '';
    search: string = '';
    minSearchCharacterLimit: number = 3;
    sortType: string = '';
    sortDirection: any = '';
    isFiltersOpen: boolean = false;
    audits: any[] = [];
    allAudits: any[] = [];
    filters: any = {};
    availableFilters: any = {};
    tabs: any[] = [];

    constructor (
        private pagePerformanceAuditInfoService: PagePerformanceAuditInfoService,
        private pagePerformancePageDetailsService: PagePerformancePageDetailsService,
        private pagePerformanceAuditImpactService: AuditImpactService,
        private pagePerformanceOpportunitiesService: PagePerformanceOpportunitiesService,
        private translateService: TranslateService,
        private monEventService: MonEventService,
        private exporterService: ExporterService,
        private cdr: ChangeDetectorRef,
    ) {}

    ngOnInit (): void {
        this.activate();
    }

    getPage (): void {
        this.getPageData(false);
    }

    getLoadingStatus (): any {
        return this.pagePerformancePageDetailsService.getLoadingReportStatus();
    }

    activate (): void {
        this.initFilters();
        this.tab = 'errors';
        this.search = '';
        this.minSearchCharacterLimit = 3;
        this.sortType = 'title';
        this.sortDirection = 'asc';
        this.isFiltersOpen = false;
        this.audits = [];
        this.allAudits = this.pagePerformanceOpportunitiesService.getAudits().map((entry: any) => {
            const updatedEntry = safeClone(entry);
            updatedEntry.metrics = PAGE_PERFORMANCE_AUDIT_RELATIONS.metrics[entry.id] || [];
            return updatedEntry;
        });
        this.getPageData(false);
    }

    initFilters (): void {
        const filters = this.pagePerformancePageDetailsService.initFilters();
        this.filters = filters.filters;
        this.availableFilters = filters.availableFilters;
    }

    setTab (tabValue: string): void {
        this.tab = tabValue;
        this.getPageData(false);
    }

    onSearch (search: string): void {
        this.search = search;
        this.getPageData(true);
    }

    onFiltersChange (changes: any): void {
        if (!changes.audits.length) {
            this.initFilters();
        }

        if (changes.audits) {
            this.getPageData(false);
        }
    }

    getDifficulty (id: string): string {
        return this.pagePerformanceAuditInfoService.getDifficulty(id);
    }

    getLabelClass (audit: any): string {
        return this.pagePerformanceAuditImpactService.getImpactClass(audit);
    }

    getImpactTranslation (audit: any): string {
        return this.pagePerformanceAuditImpactService.getImpactTranslation(audit);
    }

    openDetails (audit: any): void {
        const params = {
            body: PagePerformanceDialogsAuditDetailsComponent,
            size: 'sm',
            data: {
                audit: audit,
            },
        };
        this.monEventService.run(MON_EVENTS.LOAD_DIALOG, { params });
    }

    onSortPage (event: any): void {
        this.sortDirection = event.direction;
        this.sortType = event.by;
        this.getPageData(true);
    }

    trackByAuditId (index: number, audit: any): any {
        return audit.id;
    }

    // PROTECTED

    getPageData (forceDomUpdate: boolean): void {
        const filteredAudits = this.pagePerformancePageDetailsService.filterAudits(
            this.filters,
            this.allAudits,
            this.tab,
            this.search,
        );
        this.audits = this.sortAudits(filteredAudits);
        // Renews the Tab Count when filtering search results.
        this.setupTabs();
        if (forceDomUpdate) {
            this.cdr.detectChanges();
        }
    }

    sortAudits (audits: any[]): any[] {
        return audits.sort((a: any, b: any) => {
            let aValue: any;
            let bValue: any;

            if (this.sortType === 'difficulty') {
                aValue = this.pagePerformanceAuditInfoService.getDifficultyLevel(a.id);
                bValue = this.pagePerformanceAuditInfoService.getDifficultyLevel(b.id);
            } else if (this.sortType === 'priority') {
                aValue = this.pagePerformanceAuditImpactService.getImpactValue(a);
                bValue = this.pagePerformanceAuditImpactService.getImpactValue(b);
            } else {
                aValue = a[this.sortType];
                bValue = b[this.sortType];
            }

            if (this.sortDirection === 'asc') {
                return aValue > bValue ? 1 : -1;
            } else {
                return aValue < bValue ? 1 : -1;
            }
        });
    }

    setupTabs (): void {
        let errorAudits: number;
        let passedAudits: number;
        if (this.tab === 'errors') {
            errorAudits = this.audits.length;
            passedAudits = this.allAudits.length - errorAudits;
        } else {
            passedAudits = this.audits.length;
            errorAudits = this.allAudits.length - passedAudits;
        }
        this.tabs = [
            {
                name: this.translateService.getString('Errors ([[audits]])', { audits: errorAudits }),
                value: 'errors',
            },
            {
                name: this.translateService.getString('Passed ([[audits]])', { audits: passedAudits }),
                value: 'passed',
            },
        ];
    }

    exportCsv (): any {
        return () => {
            if (this.audits) {
                return this.exporterService.parsePerformanceAudits(this.audits);
            } else {
                return null;
            }
        };
    }

    csvFileName (): string {
        if (this.tab === 'errors') {
            return this.translateService.getString('opportunities_errors.csv');
        }
        return this.translateService.getString('opportunities_passed.csv');
    }
}
